// extracted by mini-css-extract-plugin
module.exports = {"NumericOptionalRangeFeature":"vw_a bgu_b bgu_ux"};